import { NgModule } from '@angular/core';
import { ExpansionDirective } from './expansion.directive';
import { Expansion2Directive } from './expansion2.directive';

@NgModule({
  declarations: [ExpansionDirective, Expansion2Directive],
  exports: [ExpansionDirective, Expansion2Directive],
})
export class ExpansionModule {}
